<script setup lang="ts">
import FadeTransition from '@/shared/components/transition/FadeTransition.vue'

interface Props {
  loading: boolean
}

defineProps<Props>()
</script>

<template>
  <FadeTransition appear>
    <div v-if="loading" class="flex items-center justify-center text-center h-screen w-full">
      <div class="animate-pulse">
        <img src="@/assets/images/ourboxes.svg" width="400px" />
        <span class="font-light text-sm uppercase tracking-widest">Loading...</span>
      </div>
    </div>
    <slot v-else></slot>
  </FadeTransition>
</template>
